export enum EQueryKeys {
  DefaultCountryQueryKey = 'default-country-query-key',
  PersonalQueryKey = 'personal-query-key',
  CompaniesQueryKey = 'companies-query-key',
  CurrenciesQueryKey = 'currencies-query-key',
  DraftCompanyQueryKey = 'draft-company-query-key',
  IncomingPaymentsQueryKey = 'incoming-payments-query-key',
  OutgoingPaymentsQueryKey = 'outgoing-payments-query-key',
  CompanyStepQueryKey = 'company-step-query-key',
  AddressCategoriesQueryKey = 'address-categories-query-key',
  MembersQueryKey = 'members-query-key',
  PepMembersQueryKey = 'pep-members-query-key',
  CompanyTotalShareQueryKey = 'company-total-share-query-key',
  ChildSubmembersQueryKey = 'child-submembers-query-key',
  VerificationOfDirectorsQueryKey = 'verification-of-directors-query-key',
  RetryVerificationOfDirectorsQueryKey = 'retry-verification-of-directors-query-key',
  NewPepMembersQueryKey = 'new-pep-members-query-key',
}

export enum ECurrencyTickers {
  Usd = 'USD',
}
